(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  // Function to apply swatch interactions
  function applySwatchInteractions() {
    console.log('Applying swatch interactions');
    const swatches = document.querySelectorAll('.collection-product-swatches .swatches button');
    swatches.forEach(function(swatch) {
      swatch.removeEventListener('click', swatchClickHandler);
      swatch.addEventListener('click', swatchClickHandler);
    });
  }

  // Swatch click handler for buttons
  function swatchClickHandler(event) {
    const swatch = event.currentTarget;
    swatch.closest('.swatches').querySelectorAll('button').forEach(function(s) {
      s.classList.remove('active');
    });
    swatch.classList.add('active');
    const newImageUrl = swatch.getAttribute('data-swatch-image');
    const cardMediaImage = swatch.closest('.card').querySelector('.card__media .media img');
    if (cardMediaImage) {
      cardMediaImage.src = newImageUrl;
      cardMediaImage.srcset = newImageUrl;
    }
  }

  // Function to update image from swiper slides
  function slideClickHandler(event) {
    const slide = event.currentTarget;
    const newImageUrl = slide.getAttribute('data-swatch-image');
    const cardMediaImage = slide.closest('.card').querySelector('.card__media .media img');
    if (cardMediaImage) {
      cardMediaImage.src = newImageUrl;
      cardMediaImage.srcset = newImageUrl;
    }
  }

  // Function to initialize Swiper instances
  function initializeSwipers() {
    console.log('Initializing swipers');
    const sliders = document.querySelectorAll('.collection-product-swatches.slider');
    const textImageSliders = [];
    sliders.forEach((sliderEl,i) => {
      // Destroy existing Swiper instance if it exists
      // if (container.swiper) {
      //   container.swiper.destroy(true, true);
      // }

      const swiperContainer = sliderEl.querySelector('.swiper-container');
      const nextBtn = sliderEl.querySelector('.swiper-next-custom');
      const prevBtn = sliderEl.querySelector('.swiper-prev-custom');

      const nextClass = `swiper-next-${i}`;
      const prevClass = `swiper-prev-${i}`;
      nextBtn.classList.add(nextClass);
      prevBtn.classList.add(prevClass);
      
      textImageSliders[i] = new Swiper(swiperContainer, {
        slidesPerView: 6,
        spaceBetween: 10,
        watchOverflow: false,
        navigation: {
          nextEl: `.${nextClass}`,
          prevEl: `.${prevClass}`,
        },
      });

      // Add click event listeners to each slide after Swiper initialization
      const slides = sliderEl.querySelectorAll('.swiper-slide');
      slides.forEach((slide) => {
        slide.removeEventListener('click', slideClickHandler);
        slide.addEventListener('click', slideClickHandler);
      });
    });
  }

  // Function to reinitialize all functionality
  function reinitializeAll() {
    console.log('Reinitializing all functionality');
    setTimeout(() => {
      applySwatchInteractions();
      initializeSwipers();
    }, 1000); // Increased delay to 500ms as requested
  }

  let lastUrl = location.href;

  // Function to check URL changes
  function urlChangeHandler() {
    const currentUrl = location.href;
    if (currentUrl !== lastUrl) {
      console.log('URL changed from', lastUrl, 'to', currentUrl);
      lastUrl = currentUrl;
      reinitializeAll();
    }
  }

  // Initial setup when DOM is loaded
  document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM Content Loaded');
    reinitializeAll();
    
    // Watch for URL changes
    setInterval(urlChangeHandler, 100);
  });

  // View More Grid Items
  document.addEventListener("DOMContentLoaded", function () {
    const loadMoreButton = document.getElementById("load-more");

    if (loadMoreButton) {
      loadMoreButton.addEventListener("click", function () {
        const nextPageUrl = loadMoreButton.getAttribute("data-next-page");

        if (nextPageUrl) {
          fetch(nextPageUrl)
            .then(response => response.text())
            .then(data => {
              const parser = new DOMParser();
              const newDocument = parser.parseFromString(data, "text/html");
              const newProducts = newDocument.querySelector("#product-grid").innerHTML;
              document.querySelector("#product-grid").insertAdjacentHTML("beforeend", newProducts);
              const newNextPage = newDocument.querySelector("#load-more")?.getAttribute("data-next-page");
              if (newNextPage) {
                loadMoreButton.setAttribute("data-next-page", newNextPage);
              } else {
                loadMoreButton.style.display = "none";
              }

              reinitializeAll();
            })
            .catch(error => console.error("Error loading more products:", error));
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-anchor-nav-alt"] && !Shopify.designMode) return;
  try {
    
    document.getElementById('anchor-nav-select').addEventListener('change', function() {
    const anchor = this.value;
    if(anchor) {
      window.location.href = anchor;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-anchor-nav"] && !Shopify.designMode) return;
  try {
    
    document.getElementById('anchor-nav-select').addEventListener('change', function() {
    const anchor = this.value;
    if(anchor) {
      window.location.href = anchor;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-article-main"] && !Shopify.designMode) return;
  try {
    
    var videoSwiper = new Swiper('.video-swiper .swiper-container', {
      spaceBetween: 20,
      slidesPerView: 1,
      scrollbar: {
        el: '.video-swiper .swiper-scrollbar',
        draggable: true,
      },
      navigation: {
        nextEl: '.video-swiper .swiper-next',
        prevEl: '.video-swiper .swiper-prev',
      },
      breakpoints: {
        600: {
          slidesPerView: 1.25,
          spaceBetween: 20,
        },

        1000: {
          slidesPerView: 1.5,
          spaceBetween: 45,
        },

        1400: {
          slidesPerView: 2.15,
        },

        1600: {
          slidesPerView: 2.3,
        }
      }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-b24-scroll-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const scrollTextElement = document.getElementById('scroll-text');

    // Step 1: Loop through each <h2> and wrap each word in a span
    const headings = scrollTextElement.querySelectorAll('h2');

    headings.forEach(heading => {
      const words = heading.innerText.split(' ').map(word => `<span class="scroll-word">${word} </span>`);
      heading.innerHTML = words.join(''); // Reassemble the HTML with spans
    });

    const wordSpans = document.querySelectorAll('.scroll-word');

    // Step 2: Function to adjust opacity based on scroll position
    const adjustOpacityOnScroll = () => {
      const viewportHeight = window.innerHeight;
      const scrollY = window.scrollY;

      wordSpans.forEach(span => {
        const rect = span.getBoundingClientRect();
        const wordTop = rect.top + scrollY; // Get the position of each word in relation to the document

        // Calculate how far the word is from the viewport center
        const distanceFromCenter = Math.abs(wordTop - scrollY - viewportHeight / 2);
        const maxDistance = viewportHeight / 2;

        // If the word is in the center of the viewport or has passed, keep it fully visible
        if (distanceFromCenter < maxDistance / 4) {
          span.style.opacity = 1; // Set full opacity when near the center
          span.classList.add('fully-visible'); // Mark the word as fully visible
        } else {
          // Remove 'fully-visible' class if it's no longer close to the center
          span.classList.remove('fully-visible');
          // Calculate opacity based on distance, ranging from 0.4 to 1
          const opacity = Math.max(0.2, 1 - (distanceFromCenter / maxDistance));
          span.style.opacity = opacity;
        }
      });
    };

    // Step 3: Add event listener for scrolling
    window.addEventListener('scroll', adjustOpacityOnScroll);

    // Initial call to set opacity based on initial scroll position
    adjustOpacityOnScroll();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-b24-sliding-cards"] && !Shopify.designMode) return;
  try {
    

  // gsap.to("#slide-1", {
  //   id: "slide1-trigger",
  //   duration: 1,              
  //   scale: 0.8,               
  //   opacity: 0,               
  //   filter: "blur(10px)",     
  //   scrollTrigger: {
  //     trigger: "#slide-1",
  //     start: "top 100px", 
  //     end: "bottom top-=10%", 
  //     scrub: true,
  //     pin: true,
  //   }
  // });

  // gsap.to("#slide-2", {
  //   id: "slide1-trigger",
  //   duration: 1,
  //   scale: 0.8,
  //   opacity: 0,
  //   filter: "blur(10px)",
  //   scrollTrigger: {
  //     trigger: "#slide-2",
  //     start: "top 100px", 
  //     end: "bottom top-=10%",
  //     scrub: true,
  //     pin: true,
  //   }
  // });

  // gsap.to("#slide-3", {
  //   id: "slide1-trigger",
  //   duration: 1,
  //   scale: 0.8,
  //   opacity: 0,
  //   filter: "blur(10px)",
  //   scrollTrigger: {
  //     trigger: "#slide-3",
  //     start: "top 100px", 
  //     end: "bottom top-=10%", 
  //     scrub: true,
  //     pin: true,
  //   }
  // });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-b24-video-hero"] && !Shopify.designMode) return;
  try {
    
  
  gsap.registerPlugin(ScrollTrigger);

  var tl = gsap.timeline({
    scrollTrigger: {
      trigger: ".bl24-video-hero",
      scrub: true,
      pin: true,
      start: "top top",
      end: "+=300%",
    }
  });

  gsap.fromTo(
    ".bl24-video-hero",
    { opacity: 0},
    { opacity: 1}
  );
  
  // Slide up animation
  gsap.fromTo(
    ".video-wrapper",
    { opacity: 0, y: "50vh" },
    { opacity: 1, y: "0", duration: 1, delay: 0.5, ease: "power2.out" }
  );
  
  // Fade in and grow
  gsap.to(".video-wrapper", {
    width: "100%",
    height: "100%",
    duration: 2,
    delay: 1.5,
    ease: "power2.out",
  });
  
  // Border radius removal
  gsap.to(".video-wrapper video", {
    borderRadius: "0",
    duration: 1,
    delay: 4,
    ease: "power2.out",
  });
  
  // Brackets fade in
  gsap.fromTo(
    ".video-wrapper .brackets",
    { opacity: 0},
    { opacity: 1, duration: 1, delay: 3 }
  );

  // Brackets expand
  gsap.fromTo(
    ".video-wrapper .brackets",
    { gap: 0 },
    { gap: "200px", duration: 1, delay: 4 }
  );
  
  // Brackets medium screen expand
  if (window.innerWidth <= 1400) {
    gsap.to(".video-wrapper .brackets", { gap: "100px", duration: 1, delay: 4});
  }

  // Brackets small screen expand
  if (window.innerWidth <= 800) {
    gsap.to(".video-wrapper .brackets", { gap: "50px", duration: 1, delay: 4});
  }
  
  // Hero X scaling (replaces `growX`)
  gsap.fromTo(
    ".video-wrapper .brackets img.hero-x",
    { scale: 0 },
    { scale: 1, duration: 1, delay: 4, ease: "power2.out" }
  );

    tl.to({}, { duration: 1 }) // Dummy tween to add a delay of 1 second
    .to(".bl24-video-hero .video-wrapper video", { opacity: 0, duration: 2 })
    .to(".bl24-video-hero .video-wrapper .brackets", { opacity: 0, duration: 2 })
    .to(".bl24-video-hero .heading-wrapper .background-image", { opacity: 1 }, "+=0.1")
    .to(".bl24-video-hero .heading-wrapper h1", { opacity: 1, top: "50%", duration: 3, ease: "power2.inOut" }, "+=0.3")
    .to(".bl24-video-hero .heading-wrapper h1", { opacity: 0, top: "40%", duration: 3, ease: "power2.inOut" }, "+=0.4")
    .to(".bl24-video-hero .heading-wrapper .background-image", { opacity: 0 }, "+=0.4")
    .to(".bl24-video-hero .product-logo-wrapper h4.top-text", { opacity: 1, bottom: 0, duration: 2, ease: "power2.inOut"  }, "+=0.41")
    .to(".bl24-video-hero .product-logo-wrapper img.product-logo", { opacity: 1, bottom: 0, duration: 2, ease: "power2.inOut"  }, "+=0.42")
    .to(".bl24-video-hero .product-logo-wrapper .video-popup-toggle", { opacity: 1, bottom: 0, duration: 2, ease: "power2.inOut"  }, "+=0.43");

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-bl24-bow-features"] && !Shopify.designMode) return;
  try {
    
  //swiper
  const bowFeatureswiper = new Swiper('.bl24-bow-features .swiper-container', {
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,  // Enables smooth fading between slides
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    allowTouchMove: false, // Disables click-and-drag (touch and mouse swiping)
  });

  document.addEventListener("DOMContentLoaded", function () {
    const bars = document.querySelectorAll(".bar");

    const observerOptions = {
      root: null,
      rootMargin: "0px 0px -15%",
      threshold: 0.1,
    };

    const barObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const barInner = entry.target.querySelector(".bar-inner");
          barInner.style.width = "100%"; // Full width
        } else {
          const barInner = entry.target.querySelector(".bar-inner");
          barInner.style.width = "0"; // Reset width when out of viewport
        }
      });
    }, observerOptions);

    bars.forEach((bar) => barObserver.observe(bar));
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-bl24-card-expanders"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.details button').forEach(button => {
    button.addEventListener('click', () => {
      // Toggle 'active' class on the button itself
      button.classList.toggle('active');
      // Toggle 'active' class on the sibling '.details-text' div
      const detailsText = button.nextElementSibling;
      if (detailsText && detailsText.classList.contains('details-text')) {
        detailsText.classList.toggle('active');
      }
    });
  });

  document.querySelectorAll('.card').forEach(card => {
    const video = card.querySelector('video');

    card.addEventListener('mouseenter', () => {
      if (video) video.play();
    });

    card.addEventListener('mouseleave', () => {
      if (video) video.pause();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-bl24-finishes-simple"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const swatchButtons = document.querySelectorAll('.swatch-wrapper .swatch');
  const colorNameElement = document.querySelector('.color-name p');
  const finishImages = document.querySelectorAll('.images .finish-image');

  swatchButtons.forEach(button => {
    button.addEventListener('click', function() {
      // Remove "active" class from all buttons
      swatchButtons.forEach(btn => btn.classList.remove('active'));

      // Add "active" class to the clicked button
      this.classList.add('active');

      // Get the `data-finish-name` from the clicked swatch button
      let finishName = this.getAttribute('data-finish-name');
      
      // Convert handleized text to capitalized words with spaces
      let formattedFinishName = finishName.replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
      
      // Update the color name in the paragraph
      colorNameElement.textContent = formattedFinishName;

      // Hide all images
      finishImages.forEach(img => img.style.display = 'none');

      // Show the matching image
      const matchingImage = document.querySelector(`.finish-image[data-finish-name="${finishName}"]`);
      if (matchingImage) {
        matchingImage.style.display = 'block';
      }
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-bl24-finishes"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tabs h4");

  // Tab switching functionality
  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      tabs.forEach((t) => t.classList.remove("active"));
      this.classList.add("active");

      const targetClass = this.classList[0];
      document.querySelectorAll(".finishes-wrapper").forEach((wrapper) => {
        wrapper.classList.remove("active");
      });

      const targetWrapper = document.querySelector(`.finishes-wrapper#${targetClass}`);
      if (targetWrapper) {
        targetWrapper.classList.add("active");
      }
    });
  });

  // Swatch click functionality
  const swatches = document.querySelectorAll(".swatch-single");

  swatches.forEach((swatch) => {
    swatch.addEventListener("click", function () {
      const swatchWrapper = this.closest(".swatch-wrapper");
      const finishesWrapper = this.closest(".finishes-wrapper");

      // Clear active classes
      swatchWrapper.querySelectorAll(".swatch-single").forEach((sibling) =>
        sibling.classList.remove("active")
      );
      this.classList.add("active");

      // Update image visibility
      finishesWrapper.querySelectorAll(".images img").forEach((img) => (img.style.display = "none"));
      const targetImage = finishesWrapper.querySelector(`.images img#${this.dataset.color}`);
      if (targetImage) targetImage.style.display = "block";

      // Update color name and highlight text
      const colorNameElement = finishesWrapper.querySelector(".color-name");
      if (colorNameElement) {
        const colorName = this.dataset.colorName;
        const highlightText = this.dataset.highlightText;

        if (highlightText) {
          colorNameElement.innerHTML = `${colorName} <span>${highlightText}</span>`;
        } else {
          colorNameElement.textContent = colorName;
        }
      }
    });
  });

  // Apply .first-swatch class to the first swatch in each .swatch-wrapper on page load
  document.querySelectorAll(".swatch-wrapper").forEach((wrapper) => {
    const firstSwatch = wrapper.querySelector(".swatch-single");
    if (firstSwatch) {
      firstSwatch.classList.add("active");
      const finishesWrapper = wrapper.closest(".finishes-wrapper");

      // Set initial image and color name
      const targetImage = finishesWrapper.querySelector(`.images img#${firstSwatch.dataset.color}`);
      if (targetImage) targetImage.style.display = "block";

      const colorNameElement = finishesWrapper.querySelector(".color-name");
      if (colorNameElement) {
        const colorName = firstSwatch.dataset.colorName;
        const highlightText = firstSwatch.dataset.highlightText;

        if (highlightText) {
          colorNameElement.innerHTML = `${colorName} <span>${highlightText}</span>`;
        } else {
          colorNameElement.textContent = colorName;
        }
      }
    }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-bl24-overlapping-cards"] && !Shopify.designMode) return;
  try {
    

window.addEventListener("load", () => {
  gsap.registerPlugin(ScrollTrigger);

  gsap.to("#video-card-1", {
    duration: 1,
    scale: 0.8,
    opacity: 0,
    filter: "blur(10px)",
    scrollTrigger: {
      trigger: "#video-card-1",
      start: "top 100px",
      end: "bottom top-=10%",
      scrub: true,
      pin: true,
      pinSpacing: false,
      invalidateOnRefresh: true
    }
  });

  gsap.to("#video-card-2", {
    duration: 1,
    scale: 0.8,
    opacity: 0,
    filter: "blur(10px)",
    scrollTrigger: {
      trigger: "#video-card-2",
      start: "top 100px",
      end: "bottom top-=10%",
      scrub: true,
      pin: true,
      pinSpacing: false,
      invalidateOnRefresh: true
    }
  });

  gsap.to("#video-card-3", {
    duration: 1,
    scale: 0.8,
    opacity: 0,
    filter: "blur(10px)",
    scrollTrigger: {
      trigger: "#video-card-3",
      start: "top 100px",
      end: "bottom top",
      scrub: true,
      pin: true,
      pinSpacing: false,
      invalidateOnRefresh: true
    }
  });

  // Refresh ScrollTrigger after animations are initialized
  ScrollTrigger.refresh();
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-bl24-scroll-text-full"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const scrollTextElement = document.getElementById('scroll-text');

    // Step 1: Loop through each <h2> and wrap each word in a span
    const headings = scrollTextElement.querySelectorAll('h2');

    headings.forEach(heading => {
      const words = heading.innerText.split(' ').map(word => `<span class="scroll-word">${word} </span>`);
      heading.innerHTML = words.join(''); // Reassemble the HTML with spans
    });

    const wordSpans = document.querySelectorAll('.scroll-word');

    // Step 2: Function to adjust opacity based on scroll position
    const adjustOpacityOnScroll = () => {
      const viewportHeight = window.innerHeight;
      const scrollY = window.scrollY;

      // Calculate 35% from the top of the viewport
      const triggerPoint = viewportHeight * 0.35;

      wordSpans.forEach(span => {
        const rect = span.getBoundingClientRect();
        const wordTop = rect.top + scrollY; // Position of each word in relation to the document

        // Calculate distance from 35% point of the viewport
        const distanceFromTrigger = Math.abs(wordTop - scrollY - triggerPoint);
        const maxDistance = viewportHeight / 2;

        // If the word is near the trigger point, make it fully visible
        if (distanceFromTrigger < maxDistance / 4) {
          span.style.opacity = 1; // Full opacity near the trigger point
          span.classList.add('fully-visible'); // Mark as fully visible
        } else {
          span.classList.remove('fully-visible');
          // Calculate opacity based on distance, ranging from 0.4 to 1
          const opacity = Math.max(0.2, 1 - (distanceFromTrigger / maxDistance));
          span.style.opacity = opacity;
        }
      });
    };

    // Step 3: Add event listener for scrolling
    window.addEventListener('scroll', adjustOpacityOnScroll);

    // Initial call to set opacity based on initial scroll position
    adjustOpacityOnScroll();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-bl24-stats"] && !Shopify.designMode) return;
  try {
    
  document.querySelector('.bl24-stats .view-more p').addEventListener('click', function() {
    document.querySelectorAll('.bl24-stats .stat-single').forEach(function(stat) {
      stat.style.display = 'flex';
    });
    document.querySelector('.bl24-stats .view-more').style.display = 'none';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-bl24-swiper-manual-products"] && !Shopify.designMode) return;
  try {
    
      var swiperCollectionTab1 = new Swiper('.swiper-manual-products .swiper-container', {
      spaceBetween: 40,
      slidesPerView: 1.5,
      scrollbar: {
        el: '.swiper-manual-products .swiper-scrollbar',
        draggable: true,
      },
      navigation: {
        nextEl: '.swiper-manual-products .swiper-next',
        prevEl: '.swiper-manual-products .swiper-prev',
      },
      breakpoints: {
        600: {
          slidesPerView: 3
        },

        1000: {
          slidesPerView: 4,
          spaceBetween: 20
        },
      }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-bl24-video-grow-alt"] && !Shopify.designMode) return;
  try {
    

ScrollTrigger.matchMedia({
  // Apply GSAP animation only for screens larger than 600px
  "(min-width: 601px)": function() {
    gsap.to(".bl24-video-grow-alt .expand-image-wrapper", {
      width: "100%",
      height: "100%",
      duration: 2,
      scrollTrigger: {
        trigger: ".bl24-video-grow-alt",
        start: "top bottom",
        end: "top top",
        scrub: true
      }
    });
  },

  // Disable GSAP animation on screens 600px and below
  "(max-width: 600px)": function() {
    // No animation setup here means GSAP won't apply to .expand-image-wrapper at this size
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-bl24-video-grow"] && !Shopify.designMode) return;
  try {
    

  gsap.to(".bl24-video-grow .video-wrapper", {
    width: "100%",
    height: "100%",
    duration: 2,
    scrollTrigger: {
      trigger: ".bl24-video-grow", // Section that triggers the animation
      start: "top bottom",  // Start animation when section enters 80% of viewport height
      end: "top top",    // End when section reaches 20% of viewport
      scrub: true        // Link animation to scroll for smooth progression
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-dropdowns-50-50"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const dropdownButtons = document.querySelectorAll('.dropdown-single-feature button');
    const images = document.querySelectorAll('.images img');

    dropdownButtons.forEach((dropdownButton, index) => {
      dropdownButton.addEventListener('click', function() {
        // Close all other dropdowns
        dropdownButtons.forEach((btn, btnIndex) => {
          if (btn !== this) {
            btn.classList.remove('show');
            btn.nextElementSibling.classList.remove('show');
          }
        });

        // Toggle the current dropdown
        this.classList.toggle('show');
        this.nextElementSibling.classList.toggle('show');

        // Hide all images
        images.forEach(image => image.classList.remove('show'));

        // Show the corresponding image
        images[index].classList.add('show');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-experience-recipes"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var selectElement = document.getElementById('blog-filter');
    var iconElement = document.querySelector('img.custom-select-icon');

    // Toggle 'active' class when the select element is clicked
    selectElement.addEventListener('click', function(event) {
      iconElement.classList.toggle('active');
      event.stopPropagation(); // Prevent click from bubbling up to the document
    });

    // Remove 'active' class when clicking outside the select element
    document.addEventListener('click', function(event) {
      if (!selectElement.contains(event.target)) {
        iconElement.classList.remove('active');
      }
    });

    // Remove 'active' class and redirect when an option is selected
    selectElement.addEventListener('change', function() {
      iconElement.classList.remove('active');
      window.location.href = this.value; // Redirect on change
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-link-nav"] && !Shopify.designMode) return;
  try {
    
    document.getElementById('link-nav-select').addEventListener('change', function() {
    const anchor = this.value;
    if(anchor) {
      window.location.href = anchor;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-main-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  
  const selectElement = document.querySelector('.linkdropdowns select');
  const buttonElement = document.querySelector('.linkdropdowns .btn');

  // Disable the anchor tag visually and functionally
  buttonElement.classList.add('disabled');
  buttonElement.style.pointerEvents = 'none';
  buttonElement.style.opacity = '0.5'; // Optional: Visually indicate it's disabled

  selectElement.addEventListener('change', function() {
    if (selectElement.value) {
      buttonElement.classList.remove('disabled');
      buttonElement.style.pointerEvents = 'auto';
      buttonElement.style.opacity = '1'; // Restore normal appearance
      buttonElement.href = selectElement.value;
    } else {
      buttonElement.classList.add('disabled');
      buttonElement.style.pointerEvents = 'none';
      buttonElement.style.opacity = '0.5'; // Make it look disabled again
    }
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-scroll-reveal-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const scrollTextElement = document.getElementById('scroll-text');

    // Step 1: Loop through each <h2> and wrap each word in a span
    const headings = scrollTextElement.querySelectorAll('h2');

    headings.forEach(heading => {
      const words = heading.innerText.split(' ').map(word => `<span class="scroll-word">${word} </span>`);
      heading.innerHTML = words.join(''); // Reassemble the HTML with spans
    });

    const wordSpans = document.querySelectorAll('.scroll-word');

    // Step 2: Function to adjust opacity based on scroll position
    const adjustOpacityOnScroll = () => {
      const viewportHeight = window.innerHeight;
      const scrollY = window.scrollY;

      wordSpans.forEach(span => {
        const rect = span.getBoundingClientRect();
        const wordTop = rect.top + scrollY; // Get the position of each word in relation to the document

        // Calculate how far the word is from the viewport center
        const distanceFromCenter = Math.abs(wordTop - scrollY - viewportHeight / 2);
        const maxDistance = viewportHeight / 2;

        // If the word is in the center of the viewport or has passed, keep it fully visible
        if (distanceFromCenter < maxDistance / 4) {
          span.style.opacity = 1; // Set full opacity when near the center
          span.classList.add('fully-visible'); // Mark the word as fully visible
        } else {
          // Remove 'fully-visible' class if it's no longer close to the center
          span.classList.remove('fully-visible');
          // Calculate opacity based on distance, ranging from 0.4 to 1
          const opacity = Math.max(0.2, 1 - (distanceFromCenter / maxDistance));
          span.style.opacity = opacity;
        }
      });
    };

    // Step 3: Add event listener for scrolling
    window.addEventListener('scroll', adjustOpacityOnScroll);

    // Initial call to set opacity based on initial scroll position
    adjustOpacityOnScroll();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-swiper-cards-alt"] && !Shopify.designMode) return;
  try {
    
  var swiperCards = new Swiper('.swiper-cards-alt .swiper-container', {
    slidesPerView: 1.25,
    spaceBetween: 20,
    scrollbar: {
      el: '.swiper-cards-alt .swiper-scrollbar',
      draggable: true,
    },
    navigation: {
      nextEl: '.swiper-cards-alt .swiper-next',
      prevEl: '.swiper-cards-alt .swiper-prev',
    },
    breakpoints: {
      500: {
        slidesPerView: 2.15,
      },
      800: {
        slidesPerView: 3.15,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 3.15,
      },
      1500: {
        slidesPerView: 4.15,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-swiper-cards-short"] && !Shopify.designMode) return;
  try {
    
  var swiperCardsShort = new Swiper('.swiper-cards-short .swiper-container', {
    slidesPerView: 1.25,
    spaceBetween: 20,
    scrollbar: {
      el: '.swiper-cards-short .swiper-scrollbar',
      draggable: true,
    },
    navigation: {
      nextEl: '.swiper-cards-short .swiper-next',
      prevEl: '.swiper-cards-short .swiper-prev',
    },
    breakpoints: {
      500: {
        slidesPerView: 2.15,
      },
      800: {
        slidesPerView: 3.15,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 3.15,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-swiper-cards"] && !Shopify.designMode) return;
  try {
    
  var swiperCards = new Swiper('.swiper-cards .swiper-container', {
    slidesPerView: 1.25,
    spaceBetween: 20,
    scrollbar: {
      el: '.swiper-cards .swiper-scrollbar',
      draggable: true,
    },
    navigation: {
      nextEl: '.swiper-cards .swiper-next',
      prevEl: '.swiper-cards .swiper-prev',
    },
    breakpoints: {
      500: {
        slidesPerView: 2.15,
      },
      800: {
        slidesPerView: 3.15,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 3.15,
      },
      1500: {
        slidesPerView: 4.15,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-tabbed-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    // Select all the tabs and content containers
    const tabs = document.querySelectorAll(".tabbed-content .tabs .tab");
    const contents = document.querySelectorAll(".tabbed-content .tab-content-single");

    // Add click event to each tab
    tabs.forEach((tab, index) => {
      tab.addEventListener("click", function () {
        // Remove active classes from all tabs and contents
        tabs.forEach((tab) => tab.classList.remove("active"));
        contents.forEach((content) => content.classList.remove("active"));

        // Add active class to clicked tab and corresponding content
        tab.classList.add("active");
        contents[index].classList.add("active");
      });
    });

    // Set the first tab and content as active by default
    if (tabs.length > 0) {
      tabs[0].classList.add("active");
      contents[0].classList.add("active");
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-team-filters"] && !Shopify.designMode) return;
  try {
    
  document.querySelector('#view-more').addEventListener('click', function() {
    const gridItems = document.querySelectorAll('.team-filters .grid-item');
    gridItems.forEach(function(item) {
      item.style.display = 'block';
    });
    
    // Hide the #view-more button
    this.style.display = 'none';
  });


  } catch(e) { console.error(e); }
})();
})();
